export var SIZE_EXTRA_LARGE = 23;
export var SIZE_LARGE = 19;
export var SIZE_DEFAULT = 16;
export var SIZE_DETAIL = 14;
export var SIZE_LEGAL = 12;
//# sourceMappingURL=index.js.map